module.exports = __webpack_public_path__ + "static/media/calendario.0f947dc3.svg";